import { Observable } from "rxjs/Observable"

import {
    postImageConfig,
    getURLSearchParams,
    dashboardBaseUrl
} from "./utils/network-config"

export function postPlaceholder(token, placeholder, parameters) {
    let { image, ...placeholderProperties } = placeholder
    const { body, headers } = postImageConfig(image, token)
    Object.keys(placeholderProperties).forEach(propertyName =>
        body.append(propertyName, placeholderProperties[propertyName])
    )
    return Observable.ajax
        .post(getPlaceholderUrl(parameters), body, headers)
        .map(xhr => xhr.response)
}

function getPlaceholderUrl(parameters) {
    let url = `${dashboardBaseUrl}/placeholder`
    if (parameters && parameters.size > 0)
        url += `?` + getURLSearchParams(parameters)
    return url
}
